(function () {
  if (window.__cartCouponsInit) return;
  window.__cartCouponsInit = true;

  var COPIED_CLASS = 'is-copied';
  var RESET_DELAY = 2000;
  var resetTimers = new WeakMap();

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    var succeeded = false;
    try {
      succeeded = document.execCommand('copy');
    } catch (error) {
      succeeded = false;
    }

    document.body.removeChild(textarea);
    return succeeded;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return fallbackCopy(text) ? Promise.resolve() : Promise.reject(new Error('Copy command failed'));
  }

  function setStatus(card, message) {
    if (!card) return;
    var status = card.parentElement && card.parentElement.querySelector('.cart-coupons__status');
    if (status) status.textContent = message;
  }

  function handleCopySuccess(button, code) {
    var existingTimer = resetTimers.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);

    button.classList.add(COPIED_CLASS);
    setStatus(button.closest('.cart-coupons__card'), 'Coupon code ' + code + ' copied');

    var timer = window.setTimeout(function () {
      button.classList.remove(COPIED_CLASS);
    }, RESET_DELAY);
    resetTimers.set(button, timer);
  }

  function handleCopyFailure(button) {
    setStatus(button.closest('.cart-coupons__card'), 'Press Ctrl+C to copy');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-coupon-copy]');
    if (!button) return;

    var code = button.getAttribute('data-code');
    if (!code) return;

    copyText(code)
      .then(function () {
        handleCopySuccess(button, code);
      })
      .catch(function () {
        handleCopyFailure(button);
      });
  });

  // Click-and-drag horizontal scrolling for .cart-coupons__track, delegated
  // on the document (rather than bound per-track at load time) so it works
  // equally for markup rendered directly and for the coupons the cart
  // drawer fetches and injects later via <cart-drawer-coupons>.
  var DRAG_THRESHOLD = 6;
  var activeTrack = null;
  var isDragging = false;
  var justDragged = false;
  var startX = 0;
  var startScrollLeft = 0;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var track = event.target.closest && event.target.closest('.cart-coupons__track');
    if (!track) return;

    activeTrack = track;
    isDragging = false;
    startX = event.clientX;
    startScrollLeft = track.scrollLeft;
  });

  document.addEventListener('pointermove', function (event) {
    if (!activeTrack) return;

    var delta = event.clientX - startX;

    if (!isDragging) {
      if (Math.abs(delta) < DRAG_THRESHOLD) return;
      isDragging = true;
      activeTrack.classList.add('is-dragging');
      activeTrack.setPointerCapture(event.pointerId);
    }

    event.preventDefault();
    activeTrack.scrollLeft = startScrollLeft - delta;
  });

  function endDrag(event) {
    if (!activeTrack) return;

    if (isDragging) {
      justDragged = true;
      activeTrack.classList.remove('is-dragging');
      if (activeTrack.hasPointerCapture(event.pointerId)) {
        activeTrack.releasePointerCapture(event.pointerId);
      }
      window.setTimeout(function () {
        justDragged = false;
      }, 0);
    }

    activeTrack = null;
    isDragging = false;
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('pointerleave', function (event) {
    if (activeTrack && !isDragging) endDrag(event);
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!justDragged) return;
      if (!event.target.closest('.cart-coupons__track')) return;
      event.preventDefault();
      event.stopPropagation();
      justDragged = false;
    },
    true
  );

  // The cart drawer renders site-wide (any page), but coupon blocks are only
  // configured once, on the actual cart page's section (single source of
  // truth). Rather than trying to share that section's data across two
  // Liquid render contexts — not supported; a section can't render another
  // section, and there's no cross-section settings accessor — the drawer
  // just fetches the live /cart page and copies its already-rendered
  // .cart-coupons markup into this placeholder.
  if (!customElements.get('cart-drawer-coupons')) {
    class CartDrawerCoupons extends HTMLElement {
      connectedCallback() {
        var cartUrl = this.getAttribute('data-cart-url') || '/cart';

        fetch(cartUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then((response) => {
            if (!response.ok) throw new Error('Failed to load cart page: ' + response.status);
            return response.text();
          })
          .then((text) => {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var content = doc.querySelector('.cart-coupons');
            if (!content) return;
            this.innerHTML = '';
            this.appendChild(content);
            this.hidden = false;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }

    customElements.define('cart-drawer-coupons', CartDrawerCoupons);
  }
})();
